import { getAdmAssignedCustomers } from "@/graphql/schemas/shared/utils/getAdmAssignedCustomers"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { enrichCustomers } from "../utils/additionalData"

export const queryCustomers = {
  async customers(parent, args, context, info) {
    const { offset, limit, sort } = args

    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.CUSTOMERS,
      operation: Operations.READ,
    })

    let customers = []

    if (!user.loggedInAdm.admNumber)
      return {
        limit,
        offset,
        count: 0,
        total: 0,
        items: [],
      }

    customers = await getAdmAssignedCustomers({
      admNumber: user.loggedInAdm.admNumber,
      tourSchedules: null,
      limit,
      offset,
      sort,
    })

    customers = customers || {
      limit,
      offset,
      count: 0,
      total: 0,
      items: [],
    }

    if (customers.results instanceof Array) {
      customers.items = enrichCustomers(customers.results)
      delete [customers.results]
    }

    return customers
  },
}
